import Vue from "vue";
//import store from "./config/store.js";
import Router from "vue-router";
import Main from "@/components/Main.vue";
import Login from "@/components/Login.vue";
import NotFound from "@/components/NotFound.vue";
import Sobre from "@/components/Sobre.vue";
import "./plugins/vue-session";
import AdicionarEscala from "@/components/escalas/AdicionarEscala.vue";
import VisualizarEscala from "@/components/escalas/VisualizarEscala.vue";
import Escalas from "@/components/escalas/Escalas.vue";
import MenuEscalas from "@/components/escalas/MenuEscalas.vue";
import AutorizarEmLote from "@/components/emlote/Autorizar.vue";
import ExcluirEmLote from "@/components/emlote/Excluir.vue";
import AtivacaoUsuario from "@/components/usuarios/Ativacao";
import MenuPlantoes from "@/components/plantoes/MenuPlantoes";
import Mural from "@/components/Mural";
import ConfirmacaoDeRefeicoes from "@/components/relatorios/ConfirmacaoDeRefeicoes";
import QuantitativoDeRefeicoes from "@/components/relatorios/QuantitativoDeRefeicoes";
import RegistroDeEntrada from "@/components/relatorios/RegistroDeEntrada";
import ExtratoDePaciente from "@/components/relatorios/ExtratoDePaciente";
import ProfissionaisEscalados from "@/components/relatorios/ProfissionaisEscalados";
import Absenteismo from "@/components/relatorios/Absenteismo";
import Dormitorios from "@/components/casadagestante/Dormitorios.vue";
import MenuDormitorios from "@/components/casadagestante/MenuDormitorios.vue";
import AdicionarDormitorio from "@/components/casadagestante/AdicionarDormitorio.vue";
import CasaDaGestantePerfis from "@/components/casadagestante/Perfis.vue";
import CasaDaGestanteMenuPerfis from "@/components/casadagestante/MenuPerfis.vue";
import CasaDaGestanteAdicionarPerfil from "@/components/casadagestante/AdicionarPerfil.vue";
import Censo from "@/components/casadagestante/Censo.vue";
import MenuCenso from "@/components/casadagestante/MenuCenso.vue";
import Internar from "@/components/casadagestante/Internar.vue";
import CasaDaGestanteAutorizarEmLote from "@/components/casadagestante/AutorizarEmLote.vue";
import CasaDaGestanteExcluirEmLote from "@/components/casadagestante/ExcluirEmLote.vue";
import TiposDePlantao from "@/components/tiposdeplantao/TiposDePlantao"
import MenuTiposDePlantao from "@/components/tiposdeplantao/MenuTiposDePlantao"
import AdicionarTiposDePlantao from "@/components/tiposdeplantao/AdicionarTiposDePlantao"
import TiposEscala from "@/components/escalas/TiposEscala"
import MenuTiposEscala from "@/components/escalas/MenuTiposEscala"
import AdicionarTiposEscala from "@/components/escalas/AdicionarTiposEscala"
import MeusAbsenteismos from '@/components/plantoes/MeusAbsenteismos'

Vue.use(Router);

// construindo componenetes no modo lazy
const Refeicoes = () =>
	import(
		/* webpackChunkName: "refeicoes" */ "@/components/refeicoes/Refeicoes.vue"
	);
const MenuRefeicoes = () =>
	import(
		/* webpackChunkName: "refeicoes" */ "@/components/refeicoes/MenuRefeicoes.vue"
	);
const AdicionarAutorizacaoRefeicao = () =>
	import(
		/* webpackChunkName: "refeicoes" */ "@/components/refeicoes/Adicionar.vue"
	);
const AdicionarUsuario = () =>
	import(
		/* webpackChunkName: "usuarios" */ "@/components/usuarios/AdicionarUsuario.vue"
	);
const MenuUsuarios = () =>
	import(
		/* webpackChunkName: "usuarios" */ "@/components/usuarios/MenuUsuarios.vue"
	);
const Usuarios = () =>
	import(
		/* webpackChunkName: "usuarios" */ "@/components/usuarios/Usuarios.vue"
	);
const Perfis = () =>
	import(/* webpackChunkName: "perfis" */ "@/components/perfis/Perfis.vue");
const MenuPerfis = () =>
	import(
		/* webpackChunkName: "perfis" */ "@/components/perfis/MenuPerfis.vue"
	);
const AdicionarPerfil = () =>
	import(
		/* webpackChunkName: "perfis" */ "@/components/perfis/AdicionarPerfil.vue"
	);
const TiposDeRefeicoesMenu = () =>
	import(
		/* webpackChunkName: "tiposderefeicoes" */ "@/components/refeicoes/TiposDeRefeicoesMenu.vue"
	);
const TiposDeRefeicoes = () =>
	import(
		/* webpackChunkName: "tiposderefeicoes" */ "@/components/refeicoes/TiposDeRefeicoes.vue"
	);
const AdicionarTiposDeRefeicoes = () =>
	import(
		/* webpackChunkName: "tiposderefeicoes" */ "@/components/refeicoes/AdicionarTiposDeRefeicoes.vue"
	);
const Configuracoes = () =>
	import(
		/* webpackChunkName: "configuracoes" */ "@/components/configuracoes/Configuracoes.vue"
	);
const MenuConfiguracoes = () =>
	import(
		/* webpackChunkName: "configuracoes" */ "@/components/configuracoes/MenuConfiguracoes.vue"
	);
const EditarConfiguracoes = () =>
	import(
		/* webpackChunkName: "configuracoes" */ "@/components/configuracoes/EditarConfiguracoes.vue"
	);	
	const AdicionarFeriado = () =>
	import(
		/* webpackChunkName: "Feriados" */ "@/components/feriados/AdicionarFeriado.vue"
	);
const MenuFeriados = () =>
	import(
		/* webpackChunkName: "Feriados" */ "@/components/feriados/MenuFeriados.vue"
	);
const Feriados = () =>
	import(
		/* webpackChunkName: "Feriados" */ "@/components/feriados/Feriados.vue"
	);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			name: "inicio",
			path: "/inicio",
			component: Main,
			meta: {
				isPublic: false,
			},
			children: [
				{
					name: "plantoes",
					path: "/plantoes",
					component: MenuPlantoes,
					meta: {
						isPublic: false,
					},
				},
				{
					name: "meusabsenteismos",
					path: "/meusabsenteismos",
					component: MeusAbsenteismos,
					meta: {
						isPublic: false
					}
				},
				{
					name: "configuracoes",
					path: "/configuracoes",
					component: Configuracoes,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuConfiguracoes,
						},
						{
							path: "editar/:id",
							component: EditarConfiguracoes,
						},
					],
				},
				{
					name: "dormitorios",
					path: "/casadagestante/dormitorio",
					component: Dormitorios,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuDormitorios,
						},
						{
							path: "editar/:id",
							component: AdicionarDormitorio,
						},
						{
							path: "adicionar",
							component: AdicionarDormitorio,
						},
					],
				},
				{
					name: "perfis",
					path: "/casadagestante/perfil",
					component: CasaDaGestantePerfis,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: CasaDaGestanteMenuPerfis,
						},
						{
							path: "editar/:id",
							component: CasaDaGestanteAdicionarPerfil,
						},
						{
							path: "adicionar",
							component: CasaDaGestanteAdicionarPerfil,
						},
					],
				},
				{
					name: "censo",
					path: "/casadagestante/censo",
					component: Censo,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuCenso,
						},
						{
							path: "internar/:dormitorio_id",
							component: Internar,
						},
						{
							path: "editar/:dormitorio_id",
							component: Internar,
						},
					],
				},
				{
					name: "casadagestanteautorizaremlote",
					path: "/casadagestante/emlote/autorizar",
					component: CasaDaGestanteAutorizarEmLote,
				},
				{
					name: "casadagestanteexcluiremlote",
					path: "/casadagestante/emlote/excluir",
					component: CasaDaGestanteExcluirEmLote,
				},
				{
					name: "sobre",
					path: "/sobre",
					component: Sobre,

					meta: {
						isPublic: false,
					},
				},
				{
					name: "autorizarrefeicao",
					path: "/refeicoes",
					component: Refeicoes,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuRefeicoes,
						},
						{
							path: "adicionar",
							component: AdicionarAutorizacaoRefeicao,
						},
						{
							path: "editar/:id",
							component: AdicionarAutorizacaoRefeicao,
						},
					],
				},
				{
					name: "adicionarescala",
					path: "/escalas",
					component: Escalas,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuEscalas,
						},
						{
							path: "adicionar",
							component: AdicionarEscala,
						},
						{
							path: "editar/:id",
							component: AdicionarEscala,
						},
						{
							path: "visualizar/:id",
							component: VisualizarEscala,
						},
					],
				},
				{
					name: "usuarios",
					path: "/usuarios",
					component: Usuarios,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuUsuarios,
						},
						{
							path: "adicionar",
							component: AdicionarUsuario,
						},
						{
							path: "editar/:id",
							component: AdicionarUsuario,
						},
					],
				},
				{
					name: "feriados",
					path: "/feriados",
					component: Feriados,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuFeriados,
						},
						{
							path: "adicionar",
							component: AdicionarFeriado,
						},
						{
							path: "editar/:id",
							component: AdicionarFeriado,
						},
					],
				},
				{
					name: "perfis",
					path: "/perfis",
					component: Perfis,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuPerfis,
						},
						{
							path: "adicionar",
							component: AdicionarPerfil,
						},
						{
							path: "editar/:id",
							component: AdicionarPerfil,
						},
					],
				},
				{
					name: "tiposderefeicoes",
					path: "/tiposderefeicoes",
					component: TiposDeRefeicoes,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: TiposDeRefeicoesMenu,
						},
						{
							path: "adicionar",
							component: AdicionarTiposDeRefeicoes,
						},
						{
							path: "editar/:id",
							component: AdicionarTiposDeRefeicoes,
						},
					],
				},
				{
					name: "tiposdeplantao",
					path: "/tiposdeplantao",
					component: TiposDePlantao,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuTiposDePlantao,
						},
						{
							path: "adicionar",
							component: AdicionarTiposDePlantao,
						},
						{
							path: "editar/:id",
							component: AdicionarTiposDePlantao,
						},
					],
				},
				{
					name: "tiposdeescala",
					path: "/tiposdeescala",
					component: TiposEscala,
					meta: {
						isPublic: false,
					},
					children: [
						{
							path: "",
							component: MenuTiposEscala,
						},
						{
							path: "adicionar",
							component: AdicionarTiposEscala,
						},
						{
							path: "editar/:id",
							component: AdicionarTiposEscala,
						},
					],
				},
				{
					name: "autorizacaoemlote",
					path: "/emlote/autorizar",
					component: AutorizarEmLote,
				},
				{
					path: "/emlote/excluir",
					component: ExcluirEmLote,
				},
				{
					name: "confirmacaorefeicoes",
					path: "/relatorio/confirmacaoderefeicao",
					component: ConfirmacaoDeRefeicoes,
					meta: {
						isPublic: false,
					},
				},
				{
					name: "quantitativoderefeicoes",
					path: "/relatorio/quantitativoderefeicoes",
					component: QuantitativoDeRefeicoes,
					meta: {
						isPublic: false,
					},
				},
				{
					name: "registrodeentrada",
					path: "/relatorio/registrodeentrada",
					component: RegistroDeEntrada,
					meta: {
						isPublic: false,
					},
				},
				{
					name: "extratodepaciente",
					path: "/relatorio/extratodepaciente",
					component: ExtratoDePaciente,
					meta: {
						isPublic: false,
					},
				},
				{
					name: "profisisonaisescalados",
					path: "/relatorio/profissionaisescalados",
					component: ProfissionaisEscalados,
					meta: {
						isPublic: false,
					},
				},
				{
					name: "absenteismo",
					path: "/relatorio/absenteismo",
					component: Absenteismo,
					meta: {
						isPublic: false,
					},
				},
			],
		},
		{
			path: "/mural",
			component: Mural,
			meta: {
				isPublic: false,
			},
		},
		{
			path: "/usuario/cadastro",
			component: AtivacaoUsuario,
			meta: {
				isPublic: true,
			},
		},
		{
			name: "login",
			path: "/login",
			component: Login,
			meta: {
				isPublic: true,
			},
		},
		{
			path: "*",
			redirect: "/notfound",
			meta: {
				isPublic: true,
			},
		},
		{
			path: "/notfound",
			component: NotFound,
			meta: {
				isPublic: true,
			},
		},
	],
});

router.beforeEach((to, from, next) => {
	if (!to.meta.isPublic) {
		if (!Vue.prototype.$session.exists()) {
			next({
				path: "/login",
				query: {
					redirect: to.fullPath,
				},
			});
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router;
